import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../actions/marketTrends';
import { IMarketTrand } from '../../types/redux/marketTrand';
import { EDiffPriceTrand } from '../../repositories/valuation-offer-history/entities/market_trand/GetMarketTrandResponseSchema';
import { EQueryParameters as EPeriod, EQueryParameters_1 as ERoomsCount } from '../../repositories/valuation-offer-history/v1/get-market-trand';
import {
  EDemandDiffTrand,
  EMarketType,
  ESupplyDiffTrand,
} from '../../repositories/valuation-offer-history/entities/market_trand/GetSupplyDemandResponseSchema';

export const initialState: IMarketTrand = {
  filters: {
    oneRoom: false,
    twoRooms: false,
    threeRooms: false,
    fourPlusRooms: false,
    studio: false,
    all: false,
    supplyDemandShow: false,
  },
  marketTrendData: {
    marketTrand: [],
    houseTrand: [],
    averagePrice: '',
    averageSqmPrice: '',
    diffPercent: '',
    diffPrice: '',
    diffPriceTrand: EDiffPriceTrand.NoChange,
  },
  supplyDemandData: {
    demandDiff: '',
    demandTrand: [],
    demandDiffTrand: EDemandDiffTrand.NoChange,
    supplyDiff: '',
    marketType: EMarketType['Нет отрисовки'],
    supplyTrand: [],
    marketTypeDescription: '',
    supplyDiffTrand: ESupplyDiffTrand.NoChange,
  },
  isAvailableFiltersLoading: false,
  isMarketTrandLoading: false,
  isSupplyDemandLoading: false,
  roomsCount: ERoomsCount.All,
  period: EPeriod.All,
};

export const marketTrandReducer = (state = initialState, { type, payload }: TReduxActions) => {
  switch (type) {
    case EActionTypes.GetAvailableFilters: {
      return {
        ...state,
        filters: payload,
      };
    }
    case EActionTypes.GetMarketTrend:
      return {
        ...state,
        marketTrendData: payload,
      };

    case EActionTypes.GetSupplyDemand:
      return {
        ...state,
        supplyDemandData: payload,
      };

    case EActionTypes.SetAvailableFiltersLoading:
      return {
        ...state,
        isAvailableFiltersLoading: payload,
      };

    case EActionTypes.SetMarketTrendLoading:
      return {
        ...state,
        isMarketTrandLoading: payload,
      };

    case EActionTypes.SetSupplyDemandLoading:
      return {
        ...state,
        isSupplyDemandLoading: payload,
      };

    case EActionTypes.SetRoomsCountInFilter:
      return {
        ...state,
        roomsCount: payload,
      };

    case EActionTypes.SetPeriodInFilter:
      return {
        ...state,
        period: payload,
      };

    default:
      return state;
  }
};
